import { useSelector } from 'react-redux';

// Hook to determine if any GET API is loading
export const useGetApiLoading = () => {
  const authLoading = useSelector((state) => state.auth.loading);
  const shopifyLoading = useSelector((state) => state.shopify.loading);
  const knowledgeBaseLoading = useSelector((state) => state.knowledgeBase.loading);
  
  // Return true if any GET API is loading
  return authLoading || shopifyLoading || knowledgeBaseLoading;
};

// Hook to get loading state for a specific reducer
export const useReducerLoading = (reducerName) => {
  return useSelector((state) => state[reducerName]?.loading || false);
};
